import $axios from "../../api/axios";

function getUserDtlApi({ params, callback }) {
  if (params) {
    $axios
      .get(`/api/user?sessionId=${params}`)
      .then(res => {
        callback(res);
      })
      .catch(err => {
        console.log(err);
      });
  } else {
    $axios
      .get(`/api/user`)
      .then(res => {
        callback(res);
      })
      .catch(err => {
        console.log(err);
      });
  }
}

function submitUserInfoApi({ params, callback }) {
  $axios
    .put(`/api/user`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function matchPasswordApi({params, callback}) {
  $axios.post(`/api/user/matchPassword`, params).then(res => {
    callback(res)
  }).catch(err => {
    console.log(err)
  })
}
function changePasswordApi({params, callback}) {
  $axios.put(`/api/user/changePassword`, params).then(res => {
    callback(res)
  }).catch(err => {
    console.log(err)
  })
}
function getCosByMonApi({ callback }) {
  $axios
    .get(`/api/commission/months/1/12`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getCosByYearApi({ callback }) {
  $axios
    .get(`/api/commission/year/1/12`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getInvoiceNumsApi({ callback }) {
  $axios
    .get(`/api/invoice/due/numbers`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getSoldListApi({ callback }) {
  $axios
    .get(`/bonus/thisMonth`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function retrieveMinimalUserForRevealPriceListApi({ callback }) {
  $axios
    .get(`/api/user/minimal/reveal/priceList/`)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getUserDtlApi,
  submitUserInfoApi,
  matchPasswordApi,
  changePasswordApi,
  getCosByMonApi,
  getSoldListApi,
  getCosByYearApi,
  retrieveMinimalUserForRevealPriceListApi,
  getInvoiceNumsApi
};



// WEBPACK FOOTER //
// ./src/api/account/account.js